import styled from "styled-components";
import { theme } from "@theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 55vh;
  overflow-y: scroll;
  
  gap: 16px;
  padding-right: 24px;
  padding-left: 16px;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    flex: 1;
    max-height: none;
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    margin-top: auto;
  }
`

export const ContentButtons = styled.div`
  display: flex;
  flex-basis: fit-content;
  border: 1px solid #ccc;
  border-radius: 12px;
  overflow: hidden;
  justify-content: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  margin-bottom: 4px;
`;


export const ContentButton = styled.button`
  display: flex;
  width: 80px;
  aspect-ratio: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 251, 248, 1);
  border: none;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
  padding: 16px;


  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: #e0e0e0;
    }
  }

  &:active {
    transform: translateY(0);
  }

  &:focus {
    outline: none;
  }
`;

export const Icon = styled.div`
  font-size: 18px;
  margin-bottom: 6px;
  color: rgba(198, 166, 145, 1);
`;

export const Label = styled.div`
  font-family: 'Inter', sans-serif ;
  font-size: 12px;
  font-weight: 400;
  color: rgba(89, 78, 71, 1);
`;
